module.exports = __webpack_public_path__ + "img/normal.db87cfc9.png";